import { useQueryClient, useInfiniteQuery, UseInfiniteQueryOptions } from '@lumapps/base-api/react-query';
import { ONE_MINUTE } from '@lumapps/utils/time/constants';

import { instanceQueryKeys, searchInstances } from '../api';
import type { QueryInstanceSearchOptions } from '../api/types';
import { MINIMAL_INSTANCE_FIELDS_ARRAY, SEARCH_INSTANCE_DEFAULT_PARAMS } from '../constants';

/**
 * Search instances with react-query infinite scroll
 */
export function useQueryInstanceSearch(
    params: QueryInstanceSearchOptions,
    options?: Omit<UseInfiniteQueryOptions, 'queryKey' | 'queryFn' | 'getNextPageParam'>,
) {
    const baseParams = { ...SEARCH_INSTANCE_DEFAULT_PARAMS, itemFields: MINIMAL_INSTANCE_FIELDS_ARRAY, ...params };
    const queryClient = useQueryClient();
    return useInfiniteQuery({
        ...options,
        queryKey: instanceQueryKeys.search(baseParams),
        queryFn: async ({ pageParam, signal }) => {
            const { itemFields: itemFieldsArray, ...restParams } = baseParams;
            const itemFields = itemFieldsArray?.join(',');
            const result = await searchInstances({ itemFields, ...restParams, cursor: pageParam }, signal);
            for (const item of result.items) {
                queryClient.setQueryData(instanceQueryKeys.get(item.id, itemFieldsArray), item);
            }
            return result;
        },
        getNextPageParam: (data) => (data.more && data.cursor) || undefined,
        staleTime: 5 * ONE_MINUTE,
    });
}
